import React from 'react';
import PropTypes from 'prop-types';
import { Textarea } from './style';

const CustomTextarea = ({
  value,
  onChange,
  fixed,
  id,
  placeholder = 'Inserisci',
  mb = 24,
  minHeight = 190,
}) => {
  const handleOnChange = (e) => {
    const newValue = e.target.value?.replace(/\r\n|\r|\n/g, '<br />');
    onChange(newValue);
  };
  return (
    <Textarea
      placeholder={placeholder}
      onChange={handleOnChange}
      value={value?.replaceAll('<br />', '\n')}
      minHeight={minHeight}
      fixed={fixed}
      mb={mb}
      id={id}
    />
  );
};

CustomTextarea.propTypes = {
  minHeight: PropTypes.number,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  fixed: PropTypes.bool,
  mb: PropTypes.number,
  id: PropTypes.string.isRequired,
};

export default CustomTextarea;
